import equal from 'fast-deep-equal';
import setSiteMeta from '../base-saving-actions/set-site-meta';

const updateMetaIntegrations = (initialIntegrations, currentIntegrations) => {
  if (equal(initialIntegrations, currentIntegrations)) return [];

  const integrationsForUpdate = {
    ...initialIntegrations,
    ...currentIntegrations,
  };

  return [setSiteMeta(['integrations'], integrationsForUpdate)];
};

export default updateMetaIntegrations;
